import React from "react"
import classNames from "classnames"
import PropTypes from "prop-types"
import richTextStyles from "./Richtext-tw-styles"
import getWidth from "../../../utils/gridWidth"
import Typography from "../../Generic/Typography"

const RichText = (props) => {
    const { richtext,styles }=props
    const widthClass = getWidth(richtext.componentWidth)
    let richtextStyle = ""
    if (styles) {
        richtextStyle = richTextStyles[styles]
    } else if (
        richtext?.styles &&
        richTextStyles[richtext?.styles.trim()] !== undefined
    ) {
        richtextStyle = richTextStyles[richtext?.styles.trim()]
    }
    return (
        <Typography
            className={classNames(widthClass, richtextStyle)}
            component='div'

            dangerouslySetInnerHTML={{
                __html:DOMPurify.sanitize(richtext.body),
              }}
              tabIndex='0'
        />
            

    )
}
RichText.propTypes = {
    richtext: PropTypes.oneOfType([PropTypes.object]),
    styles:PropTypes.string,
}
export default RichText
